// // import React, { useEffect, useState } from 'react';
// // import {
// //   BrowserRouter as Router,
// //   Routes,
// //   Route,
// //   Navigate,
// // } from 'react-router-dom';
// // import './components/css/app.css';
// // import Rates from './pages/Rates';
// // import Dashboard from './pages/Dashboard';
// // import Users from './pages/Users';
// // import Login from './pages/Login';
// // import Signup from './pages/SignUp';
// // import Sidebar from './components/Sidebar';
// // import Inventory from './pages/Inventory';
// // import Orders from './pages/Order';
// // import { toast, ToastContainer } from 'react-toastify';
// // import CustomToast from './components/CustomToast';
// // import Customers from './pages/Customers';
// // import PurchaseOrder from './pages/PurchaseOrder';
// // import PackingList from './pages/PackingList';
// // import PurchaseExpenses from './pages/PurchaseExpenses';
// // import Reports from './pages/Reports';
// // import { LocalizationProvider } from '@mui/x-date-pickers';
// // import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
// // import Access from './pages/Access';

// // function App() {
// //   const [isLoggedIn, setIsLoggedIn] = useState(false);
// //   const [userRole, setUserRole] = useState('');
// //   const [isLoading, setIsLoading] = useState(true);

// //   const handleLogin = async (isLoggedInSuccessfully) => {
// //     setIsLoading(true);
// //     let user = await localStorage.getItem('user');
// //     user = JSON.parse(user);
// //     if (user?.token !== '' && user?.token) {
// //       setIsLoggedIn(true);
// //       setUserRole(user?.role || '');
// //     } else {
// //       setIsLoggedIn(isLoggedInSuccessfully);
// //     }
// //     setIsLoading(false);
// //   };

// //   useEffect(() => {
// //     handleLogin(false);
// //   }, []);



// //   const getAuthorizedRoutes = () => {
// //     const commonRoutes = [
// //       <Route key="dashboard" path="/" element={<Dashboard />} />,
// //     ];

// //     switch (userRole) {
// //       case 'admin':
// //         return [
// //           ...commonRoutes,
// //           <Route key="customers" path="/manage-customers" element={<Customers />} />,
// //           <Route key="users" path="/users" element={<Users />} />,
// //           <Route key="rates" path="/rates" element={<Rates />} />,
// //           <Route key="inventory" path="/inventory" element={<Inventory />} />,
// //           <Route key="orders" path="/orders" element={<Orders />} />,
// //           <Route key="purchase-order" path="/purchase-order" element={<PurchaseOrder />} />,
// //           <Route key="packing-list" path="/packing-list" element={<PackingList />} />,
// //           <Route key="purchase-expenses" path="/purchase-expenses" element={<PurchaseExpenses />} />,
// //           <Route key="reports" path="/reports" element={<Reports />} />,
// //           <Route key="access" path="/access" element={<Access />} />,

// //         ];
// //       case 'employee':
// //         return [
// //           ...commonRoutes,
// //           <Route key="inventory" path="/inventory" element={<Inventory />} />,
// //           <Route key="orders" path="/orders" element={<Orders />} />,
// //         ];
// //       case 'merchant':
// //         return [
// //           ...commonRoutes,
// //           <Route key="customers" path="/manage-customers" element={<Customers />} />,
// //           <Route key="purchase-order" path="/purchase-order" element={<PurchaseOrder />} />,
// //           <Route key="packing-list" path="/packing-list" element={<PackingList />} />,
// //         ];
// //       case 'customer':
// //         return [
// //           ...commonRoutes,
// //           // <Route key="inventory" path="/inventory" element={<Inventory />} />,
// //           // <Route key="orders" path="/orders" element={<Orders />} />,
// //           <Route key="purchase-order" path="/purchase-order" element={<PurchaseOrder />} />,
// //           <Route key="packing-list" path="/packing-list" element={<PackingList />} />,
// //         ];
// //       default:
// //         return commonRoutes;
// //     }
// //   };

// //   return (
// //     <LocalizationProvider dateAdapter={AdapterDayjs}>
// //       <Router>
// //         <CustomToast />
// //         <div className="App">
// //           {isLoading ? (
// //             <div>Loading...</div>
// //           ) : isLoggedIn ? (
// //             <>
// //               <Sidebar userRole={userRole} />
// //               <div className="main-content">
// //                 <Routes>
// //                   {getAuthorizedRoutes()}
// //                   <Route path="*" element={<Navigate to="/" replace />} />
// //                 </Routes>
// //               </div>
// //             </>
// //           ) : (
// //             <Routes>
// //               <Route
// //                 path="/login"
// //                 element={<Login onLogin={handleLogin} />}
// //               />
// //               <Route path="/signup" element={<Signup />} />
// //               <Route path="*" element={<Navigate to="/login" replace />} />
// //             </Routes>
// //           )}
// //         </div>
// //       </Router>
// //     </LocalizationProvider>
// //   );
// // }

// // export default App;
import React, { useEffect, useState } from 'react';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from 'react-router-dom';
import './components/css/app.css'; // Ensure this path is correct
import Rates from './pages/Rates';
import Dashboard from './pages/Dashboard';
import Users from './pages/Users';
import Login from './pages/Login';
import Signup from './pages/SignUp';
import Inventory from './pages/Inventory';
import Orders from './pages/Order';
import Customers from './pages/Customers';
import PurchaseOrder from './pages/PurchaseOrder';
import PackingList from './pages/PackingList';
import PurchaseExpenses from './pages/PurchaseExpenses';
import Reports from './pages/Reports';
import Access from './pages/Access';
import Sidebar from './components/Sidebar';
import CustomToast from './components/CustomToast';
import { toast } from 'react-toastify';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { api } from './helpers/apiRequest';

// Import Material-UI components for responsive handling
import { IconButton, Box, CircularProgress, useMediaQuery, useTheme } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu'; // Hamburger icon

function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [userRole, setUserRole] = useState('');
  const [isLoading, setIsLoading] = useState(true);
  const [allowedRoutes, setAllowedRoutes] = useState([]);
  const [user, setUser] = useState();

  // State to control sidebar visibility for small screens
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  // Material-UI hooks for responsive design
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('md')); // Example breakpoint for sidebar hiding

  const routeComponentMap = {
    dashboard: { path: '/', element: <Dashboard /> },
    customers: { path: '/manage-customers', element: <Customers /> },
    users: { path: '/users', element: <Users /> },
    rates: { path: '/rates', element: <Rates /> },
    inventory: { path: '/inventory', element: <Inventory /> },
    orders: { path: '/orders', element: <Orders /> },
    'purchase-order': { path: '/purchase-order', element: <PurchaseOrder /> },
    'packing-list': { path: '/packing-list', element: <PackingList /> },
    'purchase-expenses': { path: '/purchase-expenses', element: <PurchaseExpenses /> },
    reports: { path: '/reports', element: <Reports /> },
    access: { path: '/access', element: <Access /> },
  };

  const handleLogin = async (isLoggedInSuccessfully) => {
    setIsLoading(true);
    let currentUser = await localStorage.getItem('user'); // Use a different variable name to avoid conflict
    currentUser = JSON.parse(currentUser);

    if (currentUser?.token) {
      setIsLoggedIn(true);
      setUserRole(currentUser?.role || '');
      setUser(currentUser); // Set the user state here
      console.log("user:", currentUser);

      if (currentUser?.role !== 'admin') {
        try {
          const res = await api.get(`/users/get/routes?userId=${currentUser?.id}`);
          const routes = res.data.message
            ?.filter(r => r.allowed)
            .map(r => r.route) || [];
          setAllowedRoutes(routes);
          setUser(prev => ({ ...prev, routes: res.data.message })); // Update user with routes
        } catch (err) {
          console.error('Failed to fetch allowed routes', err);
          toast.error('Failed to fetch page access');
        }
      }
    } else {
      setIsLoggedIn(isLoggedInSuccessfully);
    }

    setIsLoading(false);
  };

  useEffect(() => {
    handleLogin(false);
  }, []);

  const getAuthorizedRoutes = () => {
    const routesToRender =
      userRole === 'admin'
        ? Object.keys(routeComponentMap)
        : allowedRoutes;

    return routesToRender
      .map((routeKey) => {
        const config = routeComponentMap[routeKey];
        return config ? (
          <Route key={routeKey} path={config.path} element={config.element} />
        ) : null;
      })
      .filter(Boolean);
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Router>
        <CustomToast />
        <div className="App">
          {isLoading ? (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
              <CircularProgress />
            </Box>
          ) : isLoggedIn ? (
            <>
              {/* Conditional rendering of Sidebar */}
              {isSmallScreen ? (
                // On small screens, Sidebar is controlled by isSidebarOpen state
                <Sidebar
                  userRole={userRole}
                  user={user}
                  isOpen={isSidebarOpen}
                  onClose={() => setIsSidebarOpen(false)} // Close sidebar when an item is clicked
                />
              ) : (
                // On large screens, Sidebar is always visible
                <Sidebar userRole={userRole} user={user} isOpen={true} />
              )}

              <div className={`main-content ${isSmallScreen && isSidebarOpen ? 'sidebar-open' : ''}`}>
                {/* Hamburger menu icon for small screens */}
                {isSmallScreen && (
                  <IconButton
                    color="inherit"
                    aria-label="open drawer"
                    edge="start"
                    onClick={() => setIsSidebarOpen(true)}
                    sx={{
                      position: 'fixed', // Keep button fixed
                      top: 16,
                      left: 16,
                      zIndex: 1300, // Ensure it's above other content
                      color: 'white', // Adjust color as needed for visibility
                      backgroundColor: 'rgba(0,0,0,0.5)', // Add a background for better visibility
                      '&:hover': {
                        backgroundColor: 'rgba(0,0,0,0.7)',
                      }
                    }}
                  >
                    <MenuIcon />
                  </IconButton>
                )}

                <Routes>
                  {getAuthorizedRoutes()}
                  <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>
              </div>
            </>
          ) : (
            <Routes>
              <Route
                path="/login"
                element={<Login onLogin={handleLogin} />}
              />
              <Route path="/signup" element={<Signup />} />
              <Route path="*" element={<Navigate to="/login" replace />} />
            </Routes>
          )}
        </div>
      </Router>
    </LocalizationProvider>
  );
}
export default App;
